module.exports = __webpack_public_path__ + "img/kaliboom_cartridge_1.37df7f9d.png";